var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoubleArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    clipPath: "url(#clip0_3416_77723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0305 5.46904C11.3234 5.76201 11.3234 6.23779 11.0305 6.53076L6.53047 11.0308C6.2375 11.3237 5.76172 11.3237 5.46875 11.0308C5.17578 10.7378 5.17578 10.262 5.46875 9.96904L9.43906 5.99873L5.47109 2.02842C5.17812 1.73545 5.17812 1.25967 5.47109 0.966699C5.76406 0.67373 6.23984 0.67373 6.53281 0.966699L11.0328 5.4667L11.0305 5.46904ZM2.03047 0.969043L6.53047 5.46904C6.82344 5.76201 6.82344 6.23779 6.53047 6.53076L2.03047 11.0308C1.7375 11.3237 1.26172 11.3237 0.96875 11.0308C0.675781 10.7378 0.675781 10.262 0.96875 9.96904L4.93906 5.99873L0.971094 2.02842C0.678125 1.73545 0.678125 1.25967 0.971094 0.966699C1.26406 0.67373 1.73984 0.67373 2.03281 0.966699L2.03047 0.969043Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3416_77723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrows);
export default __webpack_public_path__ + "static/media/DoubleArrows.6c3a9feb9f7709ba876baf1e46681f83.svg";
export { ForwardRef as ReactComponent };